import React from 'react'

import { useAppSelector } from 'redux/hooks'
import { COLLECTION_GAME_TYPE } from 'redux/collectionV2/types'

import CollectionService from 'services/collection.service'
import ToastService from 'services/toast.service'

import ConfirmDeleteModal from 'components/elements/ConfirmDeleteModal'

type Props = { open: boolean; onClose: () => void }

const DeleteCollectionModal = ({ open, onClose }: Props) => {
  const game = useAppSelector(state => state.collectionV2.game)

  const handleDeleteCollection = () => {
    return CollectionService.massDelete(game)
      .then(() => window.location.reload())
      .catch(() => ToastService.create('Unable to delete collection', 'Collection Service'))
  }

  const gameType = COLLECTION_GAME_TYPE[game]

  return (
    <ConfirmDeleteModal
      open={open}
      onClose={onClose}
      onDelete={handleDeleteCollection}
      header="Delete Collection"
      message={`Are you sure you want to delete your ${gameType} collection?`}
      buttonText="Delete my collection"
      loadingMessage={`Deleting your ${gameType} collection...`}
      delayEnabledTime={3000}
    />
  )
}

export default DeleteCollectionModal
